export function inverseLerp(a, b, n) {
    return (n - a) / (b - a);
}
export function clamp01(n) {
    if (n <= 0)
        return 0;
    if (n >= 1)
        return 1;
    return n;
}
